import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-gsa-3080-initiation',
    templateUrl: './gsa-3080-initiation.component.html',
    styleUrls: ['./gsa-3080-initiation.component.css'],
    standalone: false
})
export class Gsa3080InitiationComponent implements OnInit {
  title:any
  ngOnInit(): void {
   this.title = "GSA 3080 Initiation";
  }
}
